import React from 'react';
import { Link } from 'react-router-dom';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

const singlePharmacy = props => {
    return (
        <tr>
            <td>
                <Link to={StaticRoutePaths.PHARMACY_DETAILS + '/' + props.id}>{props.name}</Link>
            </td>
            <td />
            <td>{props.city}</td>
            <td />
            <td>{props.addressName}</td>
            <td />
            <td>{props.employees}</td>
            <td />
            <td>{props.email}</td>
            <td />
            <td>{props.phone}</td>
            <td />
            <td>{props.orderCount}</td>
            <td className="qf-hidden-box">
                <Link to={StaticRoutePaths.EDIT_PHARMACY + '/' + props.id}>
                    <i className="fa fa-pencil-square-o" />
                </Link>
            </td>
        </tr>
    );
};

export default singlePharmacy;



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/Single-pharmacy.js